import {useMutation} from '@tanstack/react-query';
import conversationMessagesUpdaters from '@/api/updaters/conversationMessages';

function useMarkAllRead() {
  return useMutation<void, Error, {conversationId: string}>({
    mutationKey: ['conversations', 'markAllRead'],
    mutationFn: ({conversationId}) =>
      conversationMessagesUpdaters.markAllRead(conversationId),
  });
}

export default useMarkAllRead;
